import { inject, bindable } from "aurelia";
import { getLogger } from "../../common/logging";
import { CurrentRoute } from "../../current-route";
import { FormSignService } from "../../services/form-sign-service";

let log = getLogger("form-sign-list");

@inject(
  FormSignService, CurrentRoute
)
export class FormSignListCustomElement {
    @bindable customerId

    constructor(formSignService, currentRoute) {
        this.formSignService = formSignService;
        this.currentRoute = currentRoute;
    }

    binding() {
        this.customer = this.currentRoute.params.customer;
        this.loaded = this.loadRows();
    }

    async loadRows() {
        try {
            const rows = await this.formSignService.list();
            this.rows = rows.filter(x=> !x.signed);
        } catch (e) {
            // Listan gick inte att hämta. Visa en tom lista i stället för att
            // krascha på rows.filter, vilket är vad som hände förut.
            log.error('Could not load signature list', e);
            this.rows = [];
        }

        log.info('Loaded', this.rows);
    }
 }
